export interface Favorite {
    to: string;
    name?: string;
}

export default class UserDataUtils {
    //========================================//
    //=============== Favorite ===============//
    //========================================//

    /**
     * Returns the favorites list with `path` added or removed.
     * Never mutates the given list (it comes straight from the redux store).
     *
     * @returns the new list, or null when there is nothing to write
     * (path already a favorite and `removeIfExist` is false).
     */
    static computeFavorites(
        favorites: Favorite[],
        path: string,
        name: string = '',
        removeIfExist: boolean = true,
    ): Favorite[] | null {
        if (!favorites.some((f: Favorite) => f.to === path)) {
            return [...favorites, { to: path, name: '' + name }];
        }
        return removeIfExist ? favorites.filter((f: Favorite) => f.to !== path) : null;
    }

    static isFavorites(datas: any, path: string): boolean {
        let res = undefined;
        if (datas?.menus?.favorites) {
            res = datas.menus.favorites.find((f) => f.to === path);
        }
        return !!res;
    }
}
